import {
  GET_CATEGORIES, GET_CATEGORIES_COMPLETED, GET_CATEGORIES_FAILED,
  GET_CATEGORY, GET_CATEGORY_COMPLETED, GET_CATEGORY_FAILED,
  ADD_CATEGORY, ADD_CATEGORY_COMPLETED, ADD_CATEGORY_FAILED,
  UPDATE_CATEGORY, UPDATE_CATEGORY_COMPLETED, UPDATE_CATEGORY_FAILED,
  UPDATE_CATEGORY_VISIBILITY, UPDATE_CATEGORY_VISIBILITY_COMPLETED, UPDATE_CATEGORY_VISIBILITY_FAILED,
  DELETE_CATEGORY, DELETE_CATEGORY_COMPLETED, DELETE_CATEGORY_FAILED, SHOW_DELETE_CATEGORY_MODAL, HIDE_DELETE_CATEGORY_MODAL,
  SEARCH_CATEGORIES, SEARCH_CATEGORIES_COMPLETED, SEARCH_CATEGORIES_FAILED,
  GET_CATEGORY_TREE, GET_CATEGORY_TREE_COMPLETED, GET_CATEGORY_TREE_FAILED
} from './actions';
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  categoriesLoading: false,
  categories: [],
  categoriesError: null,
  categoryLoading: false,
  category: null,
  categoryError: null,
  addingCategory: false,
  updatingCategory: false,
  updatingCategoryVisibility: false,
  updateCategoryVisibilityError: null,
  deleteCategoryModalVisible: false,
  categoryToDelete: null,
  categoryDeleting: false,
  search: searchDefault,
  categoryTree: {},
  categoryTreeLoading: false,
  categoryTreeError: null,
};

const categoryReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_CATEGORIES: return handleSearch(state, 'search', action.payload);
    case SEARCH_CATEGORIES_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_CATEGORIES_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_CATEGORIES: {
      return {
        ...state,
        categoriesLoading: true,
        categories: [],
        categoriesError: null,
      };
    }
    case GET_CATEGORIES_COMPLETED: {
      return {
        ...state,
        categoriesLoading: false,
        categories: action.payload.data,
      };
    }
    case GET_CATEGORIES_FAILED: {
      return {
        ...state,
        categoriesLoading: false,
        categoriesError: action.payload,
      };
    }
    case GET_CATEGORY: {
      return {
        ...state,
        categoryLoading: true,
        category: null,
        categoryError: null,
      };
    }
    case GET_CATEGORY_COMPLETED: {
      return {
        ...state,
        categoryLoading: false,
        category: action.payload,
      };
    }
    case GET_CATEGORY_FAILED: {
      return {
        ...state,
        categoryLoading: false,
        categoryError: action.payload,
      };
    }
    case ADD_CATEGORY: {
      return {
        ...state,
        addingCategory: true,
      };
    }
    case ADD_CATEGORY_COMPLETED: {
      return {
        ...state,
        addingCategory: false,
      };
    }
    case ADD_CATEGORY_FAILED: {
      return {
        ...state,
        addingCategory: false,
      };
    }
    case UPDATE_CATEGORY: {
      return {
        ...state,
        updatingCategory: true,
      };
    }
    case UPDATE_CATEGORY_COMPLETED: {
      return {
        ...state,
        updatingCategory: false,
      };
    }
    case UPDATE_CATEGORY_FAILED: {
      return {
        ...state,
        updatingCategory: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    case UPDATE_CATEGORY_VISIBILITY: {
      return {
        ...state,
        updatingCategoryVisibility: true,
        updateCategoryVisibilityError: null,
      };
    }
    case UPDATE_CATEGORY_VISIBILITY_COMPLETED: {
      return {
        ...state,
        updatingCategoryVisibility: false,
      };
    }
    case UPDATE_CATEGORY_VISIBILITY_FAILED: {
      return {
        ...state,
        updatingCategoryVisibility: false,
        updateCategoryVisibilityError: action.payload,
      };
    }
    case SHOW_DELETE_CATEGORY_MODAL: {
      return {
        ...state,
        deleteCategoryModalVisible: true,
        categoryToDelete: action.payload,
      };
    }
    case HIDE_DELETE_CATEGORY_MODAL: {
      return {
        ...state,
        deleteCategoryModalVisible: false,
        categoryToDelete: null,
      };
    }
    case DELETE_CATEGORY: {
      return {
        ...state,
        categoryDeleting: true,
      };
    }
    case DELETE_CATEGORY_COMPLETED: {
      return {
        ...state,
        categoryDeleting: false,
      };
    }
    case DELETE_CATEGORY_FAILED: {
      return {
        ...state,
        categoryDeleting: false,
      };
    }
    case GET_CATEGORY_TREE: {
      return {
        ...state,
        categoryTreeLoading: true,
        categoryTreeError: null,
      };
    }
    case GET_CATEGORY_TREE_COMPLETED: {
      return {
        ...state,
        categoryTreeLoading: false,
        categoryTree: action.payload,
      };
    }
    case GET_CATEGORY_TREE_FAILED: {
      return {
        ...state,
        categoryTreeLoading: false,
        categoryTreeError: action.payload,
      };
    }
    default:
      return state;
  }
};

export default categoryReducer;



// WEBPACK FOOTER //
// ./src/Category/reducer.js